/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'bootstrap-select';
import Swiper, { Pagination, Navigation } from 'swiper';
import AOS from 'aos';
import sheets_data from "./sheets_data";
import './disclaimer';

Swiper.use([Pagination, Navigation]);

$(document).ready(() => {
  AOS.init();
  sheets_data.init();

  // Style all selects with bootstrap select
  $('select').selectpicker({
    style: '',
    styleBase: 'form-control',
  });

  const panels = new Swiper(".panels .swiper", {
    slidesPerView: 3,
    spaceBetween: 35,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      // when window width is >= 480px
      540: {
        slidesPerView: 2,
        spaceBetween: 35
      },
      // when window width is >= 640px
      960: {
        slidesPerView: 3,
        spaceBetween: 35
      }
    }
  });

  const timeline = new Swiper(".timeline .swiper", {
    slidesPerView: 5,
    spaceBetween: 22,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 22
      },
      // when window width is >= 480px
      540: {
        slidesPerView: 3,
        spaceBetween: 22
      },
      // when window width is >= 640px
      960: {
        slidesPerView: 5,
        spaceBetween: 22
      }
    }
  });

  const challengeSlider = new Swiper(".challenge-slider .swiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });

  $('.complaints-popup__toggle').click(function() {
    $(this).parent().toggleClass('-open');
  });

  // Remove click event for footer heading links
  $('.unclickable > a').click(function(e) {
    e.preventDefault();
  });

  /*
   * Scroll to position of opened person bio
   */
  if ($(window).width() < 540) {
    $('.collapse').on('.people shown.bs.collapse', function() {
      $('html, body').animate({
        scrollTop: $(this).offset().top - 280,
      }, 1000);
    });
  }
});

$(() => {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    var styles = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "color": "#f5f5f5"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#bdbdbd"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#757575"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#dadada"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e5e5"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#e5e4e3"
          },
          {
            "saturation": -100
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: styles,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function(){
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    var markerIcon = $marker.data('icon');

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: markerIcon,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if($marker.html()){
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function(marker){
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
      map.setCenter(bounds.getCenter());
      // Case: Multiple markers.
    } else{
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function(){
    $('.acf-map').each(function(){
      var map = initMap($(this));
    });
  });
})

/**
 * Meet the team dropdowns
 */
$(() => {
  const SNAP_LG = 992;
  const SNAP_SM = 767;

  /**
   * Fixes the flex order so the people dropdown appears in the right place.
   */
  const fixFlexOrder = () => {
    let j = 0;
    $('.js-flex-reorder>.js-flex-panel').each((i, el) => {
      const $panel = $(el);
      const $dropdown = $panel.next();
      const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const divisor = windowWidth > SNAP_LG ? 3 : windowWidth < SNAP_SM ? 1 : 2;
      const rowOrder = Math.ceil((j + 1) / divisor);
      if ( $panel.is(':visible') ) {
        // Fix flex
        $panel.css('order', rowOrder).addClass('is-number-' + (j+1));
        $dropdown.css('order', rowOrder + 1);
        j++;
      } else {
        // Reset everything else to zero
        $panel.css('order', 0);
        $dropdown.css('order', 0);
      }
    });
  };

  $('.people__nav li:first-child a[data-filter]').addClass('active');
  const teamFilterFirst = $('.people__nav li:first-child a[data-filter]').attr('data-filter');
  $('[data-teams]').hide();
  $(`[data-teams*="${teamFilterFirst}"]`).show();

  fixFlexOrder();

  $('a[data-filter]').on('click', function(){
    // Close any stray open person dropdowns
    $('section.people .collapse').collapse('hide');

    // Hide everything
    $('[data-teams]').hide();

    // Remove active class to link if it has one
    $('a[data-filter]').removeClass('active');

    // Add active class to link
    $(this).addClass('active');

    // Show according to filters
    const teamFilter = $(this).attr('data-filter');
    $(`[data-teams*="${teamFilter}"]`).show();

    // Re-apply flex order fix
    fixFlexOrder();
  })
});

/**
 * Year filter on the news and events page
 */
$(() => {
  $('#filter-date').on('change', function(){
    const $val = $(this).val(),
      currentPath = window.location.pathname,
      currentQuerystring = window.location.search;
    let newQuerystring = '';
    if ( $val.match(/\d{4}/) ) {
      let qs = `year=${$val}`;
      if ( currentQuerystring.match(/year=\d{4}/) ) {
        newQuerystring = currentQuerystring.replace(/year=\d{4}/, qs)
      } else if ( currentQuerystring === '' ) {
        newQuerystring = qs
      } else {
        newQuerystring = `${currentQuerystring}&${qs}`
      }
    } else {
      newQuerystring = currentQuerystring.replace(/year=\d{4}/, '');
    }
    window.location.href = `${currentPath}?${newQuerystring}`
  })
})

/**
 * Category type filter
 */

$(() => {
  $('.faux-filters a').each(function() {
    if ( window.location.href.replace(/page\/\d+\//, '').endsWith($(this).attr('href')) ) {
      $(this).parent().addClass('active');
      $(this).siblings('.custom-control-input').prop('checked', true);
    }
  })
})
